import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import { bulkMatchPaymentSchema, bulkMatchPaymentListSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/bulkMatchPayments/actions';
import { BulkMatchPaymentsActionTypes as types } from 'app/ducks/bulkMatchPayments/types';
import { getPaymentEvent } from 'app/ducks/paymentEvents/actions';
import { getCompetition } from 'app/ducks/competitions/actions';

import history from 'app/routes/history';

function* createBulkMatchPaymentSaga(action): any {
  yield put(sagaActions.createBulkMatchPaymentPending(action.payload));
  const [error, response] = yield (
    yield TeammoApi(yield select())
  ).organisationBulkMatchPayments.create(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, bulkMatchPaymentSchema);
    yield put(sagaActions.createBulkMatchPaymentSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createBulkMatchPaymentFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* updateBulkMatchPaymentSaga(action): any {
  yield put(sagaActions.updateBulkMatchPaymentPending(action.payload));
  const [error, response] = yield (
    yield TeammoApi(yield select())
  ).organisationBulkMatchPayments.update(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, bulkMatchPaymentSchema);
    history.push('/');
    yield put(sagaActions.updateBulkMatchPaymentSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateBulkMatchPaymentFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* getBulkMatchPaymentSaga(action): any {
  yield put(sagaActions.getBulkMatchPaymentPending());
  const [error, response] = yield (
    yield TeammoApi(yield select())
  ).organisationBulkMatchPayments.show(action.payload);
  if (response) {
    const normalizedResponse = normalize(response, bulkMatchPaymentSchema);
    yield put(sagaActions.getBulkMatchPaymentSuccess(normalizedResponse));

    const f = normalizedResponse.entities.bulkMatchPayments[normalizedResponse.result];

    return f;
  }
  yield put(
    handleError(error, sagaActions.getBulkMatchPaymentFailed(_.isEmpty(error) ? {} : error.response.data.errors)),
  );
  return null;
}

function* getAllBulkMatchPaymentsSaga(action): any {
  yield put(
    sagaActions.getAllBulkMatchPaymentsPending(action.payload.compile ? action.payload.pagination : {}),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(yield select((state) => state.bulkMatchPayments.pagination))
    : action.payload.pagination;

  const [error, response] = yield (yield TeammoApi(yield select())).organisationBulkMatchPayments.list(
    paginationObject,
  );

  if (response) {
    const normalizedResponse = normalize(response, bulkMatchPaymentListSchema);

    yield put(
      sagaActions.getAllBulkMatchPaymentsSuccess(normalizedResponse, response.meta),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllBulkMatchPaymentsFailed(_.isEmpty(error) ? {} : error.response.data.errors),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createBulkMatchPaymentSagaWatcher(): any {
  yield takeLatest(types.CREATE_BULK_MATCH_PAYMENT_REQUESTED, createBulkMatchPaymentSaga);
}

function* updateBulkMatchPaymentSagaWatcher(): any {
  yield takeLatest(types.UPDATE_BULK_MATCH_PAYMENT_REQUESTED, updateBulkMatchPaymentSaga);
}

function* getBulkMatchPaymentSagaWatcher(): any {
  yield takeEvery(types.GET_BULK_MATCH_PAYMENT_REQUESTED, getBulkMatchPaymentSaga);
}

function* getAllBulkMatchPaymentsSagaWatcher(): any {
  yield takeEvery(types.GET_ALL_BULK_MATCH_PAYMENTS_REQUESTED, getAllBulkMatchPaymentsSaga);
}

export default function* root(): any {
  yield all([
    createBulkMatchPaymentSagaWatcher(),
    updateBulkMatchPaymentSagaWatcher(),
    getBulkMatchPaymentSagaWatcher(),
    getAllBulkMatchPaymentsSagaWatcher(),
  ]);
}
